import { SVGProps } from 'react';

const ThumbScaleSmallKindUpUpReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M3.33329 12.6667V7M12 11.3333H13.382C14.0906 11.3333 14.6932 10.8292 14.8009 10.1462L15.3163 6.87955C15.4501 6.03148 14.7772 5.26667 13.8974 5.26667H12.221C11.9567 5.26667 11.7424 5.05773 11.7424 4.8V3.15072C11.7424 2.5152 11.2141 2 10.5624 2C10.407 2 10.2661 2.08927 10.203 2.22779L9.36096 4.07533M0.666626 8.46667V11.7333C0.666626 12.2488 1.09512 12.6667 1.6237 12.6667H8.04868C8.75726 12.6667 9.35986 12.1625 9.46761 11.4795L9.98296 8.21288C10.1167 7.36482 9.4439 6.6 8.56403 6.6H6.88763C6.62334 6.6 6.40909 6.39107 6.40909 6.13333V4.48406C6.40909 3.84853 5.88079 3.33333 5.22909 3.33333C5.07365 3.33333 4.93279 3.4226 4.86966 3.56112L3.18563 7.2562C3.10882 7.42472 2.93744 7.53333 2.74833 7.53333H1.6237C1.09512 7.53333 0.666626 7.9512 0.666626 8.46667Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleSmallKindUpUpReducedTrue;
